import { TFunction } from "i18next";
import * as yup from "yup";
import { InferType } from "yup";
import { APP_VERSION_PLATFORMS } from "@/domain/app-versions.interface";

const appVersionValidationSchema = (t: TFunction) =>
  yup.object().shape({
    platform: yup
      .string()
      .required("This field is required")
      .oneOf([...APP_VERSION_PLATFORMS], "Invalid platform"),
    version: yup
      .string()
      .required("This field is required")
      .max(50, t("validations.max_length", { count: 50 })),
    apiVersion: yup
      .string()
      .required("This field is required")
      .max(50, t("validations.max_length", { count: 50 })),
    functionalVersion: yup
      .string()
      .required("This field is required")
      .max(50, t("validations.max_length", { count: 50 })),
    releaseNotes: yup.string().default(""),
    storeUrl: yup.string().default(""),
  });

export type AppVersionFormData = InferType<
  ReturnType<typeof appVersionValidationSchema>
>;

export default appVersionValidationSchema;
